import { format } from 'date-fns';
import { getMonthAvailability } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/getMonthAvailability';
import { MealCreditFormValues } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider.utils';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export type GetFirstInstanceEndDateUtcParams = Pick<
  MealCreditFormValues,
  'isMonthAvailable' | 'monthAvailableTo'
> &
  Pick<IMealCreditFormFields, 'monthAvailableOn'>;

export function getFirstInstanceEndDateUtc({
  isMonthAvailable,
  monthAvailableOn,
  monthAvailableTo,
}: GetFirstInstanceEndDateUtcParams): string | null {
  const { isMonthAvailableEveryDay } = getMonthAvailability(
    isMonthAvailable,
    monthAvailableOn
  );

  return isMonthAvailableEveryDay
    ? null
    : format(monthAvailableTo, "yyyy-MM-dd'T'HH:mm:ss'.000Z'");
}
